(function () {
  var OWN_COOKIE = 'cc_consent_decided';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function getOwnCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function setOwnCookie(name, value, days) {
    var expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
    document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/; SameSite=Lax';
  }

  ready(function () {
    var banner = document.getElementById('cookie-consent-banner');
    var panel = document.getElementById('cookie-consent-panel');
    if (!banner || !panel) return;

    var acceptBtn = document.getElementById('cookie-consent-accept');
    var rejectBtn = document.getElementById('cookie-consent-reject');
    var manageBtn = document.getElementById('cookie-consent-manage');
    var closePanelBtn = document.getElementById('cookie-consent-panel-close');
    var savePrefsBtn = document.getElementById('cookie-consent-save-prefs');
    var acceptAllPanelBtn = document.getElementById('cookie-consent-panel-accept-all');
    var rejectAllPanelBtn = document.getElementById('cookie-consent-panel-reject-all');
    var analyticsToggle = document.getElementById('cookie-consent-analytics');
    var marketingToggle = document.getElementById('cookie-consent-marketing');
    var preferencesToggle = document.getElementById('cookie-consent-preferences');

    function lockScroll() {
      document.documentElement.setAttribute('scroll-lock', '');
    }

    function unlockScroll() {
      document.documentElement.removeAttribute('scroll-lock');
    }

    function openBanner() {
      lockScroll();
      if (!banner.open) banner.showModal();
    }

    function closeBanner() {
      if (banner.open) banner.close();
    }

    function openPanel() {
      closeBanner();
      if (!panel.open) panel.showModal();
    }

    function closePanel() {
      if (panel.open) panel.close();
    }

    function getApi() {
      return window.Shopify && window.Shopify.customerPrivacy;
    }

    function finish() {
      closePanel();
      closeBanner();
      unlockScroll();
    }

    // Visibility is decided by our own first-party cookie so the banner always
    // fires even if Shopify's Customer Privacy API script is blocked, slow, or
    // fails to load (ad/tracker blockers commonly target consent scripts).
    // The API is still used, best-effort, to actually gate tracking scripts.
    function applyConsent(values) {
      setOwnCookie(OWN_COOKIE, '1', 365);
      var api = getApi();
      if (!api) {
        finish();
        return;
      }
      try {
        api.setTrackingConsent(values, finish);
      } catch (e) {
        finish();
      }
    }

    [banner, panel].forEach(function (dialog) {
      dialog.addEventListener('cancel', function (event) {
        // The visitor must use one of the explicit actions; Escape can't dismiss consent.
        event.preventDefault();
      });
    });

    acceptBtn.addEventListener('click', function () {
      applyConsent({ analytics: true, marketing: true, preferences: true, sale_of_data: true });
    });

    rejectBtn.addEventListener('click', function () {
      applyConsent({ analytics: false, marketing: false, preferences: false, sale_of_data: false });
    });

    manageBtn.addEventListener('click', openPanel);

    closePanelBtn.addEventListener('click', function () {
      closePanel();
      openBanner();
    });

    acceptAllPanelBtn.addEventListener('click', function () {
      analyticsToggle.checked = true;
      marketingToggle.checked = true;
      preferencesToggle.checked = true;
      applyConsent({ analytics: true, marketing: true, preferences: true, sale_of_data: true });
    });

    rejectAllPanelBtn.addEventListener('click', function () {
      analyticsToggle.checked = false;
      marketingToggle.checked = false;
      preferencesToggle.checked = false;
      applyConsent({ analytics: false, marketing: false, preferences: false, sale_of_data: false });
    });

    savePrefsBtn.addEventListener('click', function () {
      applyConsent({
        analytics: !!analyticsToggle.checked,
        marketing: !!marketingToggle.checked,
        preferences: !!preferencesToggle.checked,
        sale_of_data: !!marketingToggle.checked
      });
    });

    if (!getOwnCookie(OWN_COOKIE)) {
      openBanner();
    }
  });
})();
